import styles from './InfoBlock.module.scss';

const InfoBlock = ({ info_item }) => (
  <>
    <div className={styles.info_container}>
      <div className={styles.info_block}>
        <ul>
          {info_item.map(el => {
            return (
              <li key={el?.id} className={`${styles.info_block__item} d-fl`}>
                <div>
                  <img src={el?.icon?.data?.attributes?.url} alt="" width={40} height={40} />
                </div>
                <div>
                  <h4 className={styles.info_block__item_title}>{el?.title}</h4>
                  <p className={styles.info_block__item_description}>{el?.description}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  </>
);

export default InfoBlock;
